import React from 'react';
import { useTranslation } from 'react-i18next';
import { isHelixAndLearningHub } from 'utils/helix';
import { useFetchUserAnalysisSkillsContent } from 'actions/users';
import { RelatedSkillContentButton, SkillContentList } from 'screens/UserSkills';
import Stack from 'components/Stack';
import Modal from 'components/Modal';
import useUniqueId from 'hooks/useUniqueId';
import Card from 'components/Card';
import ModalHeadline from 'components/ModalHeadline';
import Box from 'components/Box';
import StickyButtonPanel from 'components/StickyButtonPanel';
import Button from 'components/Button';
import Panel from 'components/Panel';
function UserSkillContentModal(_ref) {
  var isCurrentUser = _ref.isCurrentUser,
    userId = _ref.userId,
    skillId = _ref.skillId,
    skillName = _ref.skillName,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  var _useFetchUserAnalysis = useFetchUserAnalysisSkillsContent({
      userId: userId,
      skillId: skillId,
      enabled: isHelixAndLearningHub && !!skillId
    }),
    linkedContent = _useFetchUserAnalysis.items,
    isLinkedContentError = _useFetchUserAnalysis.isError,
    isLinkedContentLoading = _useFetchUserAnalysis.isLoading;
  var hasContent = (linkedContent === null || linkedContent === void 0 ? void 0 : linkedContent.length) > 0;
  return /*#__PURE__*/React.createElement(Modal, {
    onRequestClose: onClose,
    "aria-labelledby": titleId,
    width: "extraWide"
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    sticky: true,
    title: t('skills_title_recommended_content_for', {
      name: skillName
    }),
    titleId: titleId,
    onClose: onClose
  }), /*#__PURE__*/React.createElement(Box, {
    mt: "-m",
    position: "relative",
    z: "flat",
    role: "group",
    "aria-labelledby": titleId,
    mb: "m"
  }, /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(SkillContentList, {
    isCurrentUser: isCurrentUser,
    skillName: skillName,
    isLoading: isLinkedContentLoading,
    isError: isLinkedContentError,
    linkedContent: linkedContent
  })))), /*#__PURE__*/React.createElement(StickyButtonPanel, null, hasContent && /*#__PURE__*/React.createElement(RelatedSkillContentButton, {
    name: skillName,
    size: "default"
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: onClose
  }, t('actions_close')))));
}
export default UserSkillContentModal;